import { useEffect, useState } from 'react';
import { useDisclosure } from '@withjoy/joykit';
import { CategoryFilterMobileProps } from './CategoryFilterMobile';
import { CategoryFilterData } from '../../BrandsList.controller';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useRouteMatch } from '@react-router';

export const useCategoryFilterController = (props: CategoryFilterMobileProps) => {
  const { selectedItem, handleSelect, handleClear } = props;

  const [item, setItem] = useState(selectedItem);

  const { isOpen: isDialogOpen, onOpen: onDialogOpen, onClose: onDialogClose } = useDisclosure();

  const hasBottomBar = !useRouteMatch({ path: '/shop', exact: false });

  useEffect(() => {
    setItem(selectedItem);
  }, [selectedItem]);

  const onSelect = (data: CategoryFilterData) => {
    setItem(data);
  };

  const onConfirmClick = useEventCallback(() => {
    handleSelect(item, true);
    onDialogClose();
  });

  const onClearClick = useEventCallback(() => {
    handleClear();
    onDialogClose();
  });

  const onClose = useEventCallback(() => {
    setItem(selectedItem);
    onDialogClose();
  });

  return {
    isDialogOpen,
    onDialogOpen,
    onClearClick,
    onSelect,
    onConfirmClick,
    selectedItem: item,
    onClose,
    hasBottomBar,
  };
};
